export enum FieldSize {
  M = 'm',
  L = 'l',
}

export enum SearchFormGoalName {
  HotelCalendarOpen = 'searchform_hotel_calendar_open',
  HotelCalendarCheckInSelect = 'searchform_hotel_calendar_checkin_select',
  HotelCalendarCheckOutSelect = 'searchform_hotel_calendar_checkout_select',
  HotelCalendarClose = 'searchform_hotel_calendar_close',
  HotelCalendarErrorNoCheckOut = 'searchform_hotel_calendar_error_no_checkout',
  FlexibleClick = 'calendar_flexible_click',
  SearchClick = 'btn_search_click',
}

export interface SearchFormGoal {
  name: SearchFormGoalName;
  params: Record<string, string | number>;
}

export interface SearchFormTracking {
  pageType: 'main' | 'serp' | 'hotel';
  productType: 'tour' | 'hotel';
}
